<div class="modal-header">
  <h5 class="modal-title" id="checkoutModalLabel">
    <i class="fas fa-shopping-cart"></i> Checkout Form
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="checkoutForm">

    <!-- Member Selection (single) -->
    <div class="form-group">
      <label for="member">Member:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select the member checking out the item(s)."></i>
      <ng-select id="member"
                 [items]="members$"
                 bindLabel="firstname"
                 bindValue="id"
                 formControlName="member"
                 placeholder="Select a member">
      </ng-select>
      <small class="text-danger"
             *ngIf="submitted && checkoutForm.get('member').invalid">
        Member is required.
      </small>
    </div>

    <!-- Item Barcode Multi-Selection -->
    <div class="form-group">
      <label for="itemBarcodes">Item Barcodes:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Select one or more item barcodes to check out."></i>
      <ng-select id="itemBarcodes"
                 [items]="books$"
                 bindLabel="title"
                 bindValue="id"
                 formControlName="itemBarcodes"
                 placeholder="Select barcode(s)"
                 [multiple]="true"
                 [closeOnSelect]="false"
                 [clearable]="true">
      </ng-select>
      <small class="text-muted">You can select multiple items at once.</small>
      <small class="text-danger d-block"
             *ngIf="submitted && checkoutForm.get('itemBarcodes').value?.length === 0">
        Please select at least one item.
      </small>
    </div>

    <!-- Due Date -->
    <div class="form-group">
      <label for="dueDate">Due Date:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Enter the due date for the item(s) to be returned."></i>
      <input type="date" class="form-control" id="dueDate" formControlName="dueDate">
      <small class="text-danger"
             *ngIf="submitted && checkoutForm.get('dueDate').invalid">
        Due date is required.
      </small>
    </div>

    <!-- Automatic Renewal -->
    <div class="form-group">
      <label>Automatic Renewal:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip"
         title="Choose whether the item(s) should be automatically renewed upon expiry."></i>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="automaticRenewalYes"
               value="yes" formControlName="automaticRenewal">
        <label class="form-check-label" for="automaticRenewalYes">Yes</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="automaticRenewalNo"
               value="no" formControlName="automaticRenewal">
        <label class="form-check-label" for="automaticRenewalNo">No</label>
      </div>
      <small class="text-danger"
             *ngIf="submitted && checkoutForm.get('automaticRenewal').invalid">
        Please select an automatic renewal option.
      </small>
    </div>

  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
  <button type="button" class="btn btn-outline-primary" (click)="add()">
    <i class="fas fa-shopping-cart"></i> Check Out
  </button>
</div>